<div class="mt-5">
    <form #specialForm="ngForm" novalidate="novalidate">
        <div *ngIf="currentReport && currentReport.LATEST">
            <!-- Question 1: covid-impact -->
            <div class="row mb-5">
                <div class="col-md-10">
                    <div class="label">
                        Has the Company been or will be adversely affected by COVID-19 for any party of 2020 or 2021?
                    </div>

                    <div class="color-secondary-gray font-size-14 font-weight-normal mb-3">
                        Due to the unique effects of COVID-19, all valuations projecting into 2020 will have risk specific
                        COVID-19 risk questions.
                    </div>

                    <div class="row m-0">
                        <div class="col-md-12">
                            <radio-group-button radioGroupButtonId="special-crp-covid-affected-type-radio-group"
                            [selectedOption]="currentReport.LATEST.COVID_AFFECTED" [(ngModel)]="currentReport.LATEST.COVID_AFFECTED"
                                [btnList]="effectList" [isButton]="true" name="COVID_AFFECTED" #COVID_AFFECTED="ngModel" required id="COVID_AFFECTED"
                                (optionChange)="currentReport.LATEST.COVID_AFFECTED = $event; callUpdateAPI('COVID_AFFECTED')">
                            </radio-group-button>
                        </div>
                    </div>

                    <ng-container *ngIf="currentReport.LATEST.COVID_AFFECTED">
                        <div class="mt-5">
                            <div class="label">
                                How many months of operation have been and are expected to be directly impacted by COVID-19?
                            </div>
                            <div class="color-secondary-gray font-size-14 font-weight-normal mb-3">
                                (Eg. Unable to sell inventory as usual, unable to fully staff, dramatic decrease in clients)
                            </div>

                            <div class="row">
                                <div class="col-md-12">
                                    <radio-group-button [isButton]="false" radioGroupButtonId="special-crp-covid-months--type-radio-group"
                                    [(ngModel)]="currentReport.LATEST.COVID_MONTHS"
                                        name="COVID_MONTHS" #COVID_MONTHS="ngModel" required id="COVID_MONTHS"
                                        [selectedOption]="currentReport.LATEST.COVID_MONTHS" [btnList]="monthList"
                                        (optionChange)="currentReport.LATEST.COVID_MONTHS = $event; callUpdateAPI('COVID_MONTHS')">
                                    </radio-group-button>
                                </div>
                            </div>
                        </div>
                    </ng-container>


                </div>
            </div>

            <!-- Question 2: service-type -->
            <div class="row mb-5" *ngIf="currentReport.LATEST.COVID_AFFECTED != undefined">
                <div class="col-md-10">
                    <div class="label">
                        Does the Company provide essential or nonessential services?
                    </div>
                    <div class="color-secondary-gray font-size-14 font-weight-normal mb-3">
                        Due to the unique effects of COVID-19, all valuations projecting into 2020 will have risk specific
                        COVID-19 risk questions.
                    </div>

                    <div class="row m-0">
                        <div class="col-md-12">
                            <radio-group-button [selectedOption]="currentReport.LATEST.COVID_ESSENTIAL" radioGroupButtonId="special-crp-covid-essential-type-radio-group" [(ngModel)]="currentReport.LATEST.COVID_ESSENTIAL"
                                [btnList]="serviceList" [isButton]="true" name="COVID_ESSENTIAL" #COVID_ESSENTIAL="ngModel" required id="COVID_ESSENTIAL"
                                (optionChange)="currentReport.LATEST.COVID_ESSENTIAL = $event; callUpdateAPI('COVID_ESSENTIAL')">
                            </radio-group-button>
                        </div>
                    </div>
                </div>

            </div>

            <!-- Question 3: closures-restrictions -->
            <div class="row mb-5" *ngIf="currentReport.LATEST.COVID_AFFECTED != undefined && currentReport.LATEST.COVID_ESSENTIAL != undefined">
                <div class="col-md-10">
                    <div class="label">
                        Has the Company been subject to closures or occupancy restrictions?
                    </div>

                    <div class="color-secondary-gray font-size-14 font-weight-normal mb-3">
                        Due to the unique effects of COVID-19, all valuations projecting into 2020 will have risk specific
                        COVID-19 risk questions.
                    </div>

                    <div class="row m-0">
                        <div class="col-md-12">
                            <radio-group-button [selectedOption]="currentReport.LATEST.COVID_RESTRICTIONS" [(ngModel)]="currentReport.LATEST.COVID_RESTRICTIONS"
                            radioGroupButtonId="special-crp-covid-restrictions-type-radio-group"    
                            [btnList]="yesNo_Option" [isButton]="true" name="COVID_RESTRICTIONS" #COVID_RESTRICTIONS="ngModel" required id="COVID_RESTRICTIONS"
                                (optionChange)="currentReport.LATEST.COVID_RESTRICTIONS = $event; callUpdateAPI('COVID_RESTRICTIONS')">
                            </radio-group-button>
                        </div>
                    </div>

                </div>
            </div>

            <!-- Question 4: additional-debt -->
            <div class="row mb-5" *ngIf="currentReport.LATEST.COVID_AFFECTED != undefined && currentReport.LATEST.COVID_ESSENTIAL != undefined && currentReport.LATEST.COVID_RESTRICTIONS != undefined">
                <div class="col-md-10">
                    <div class="label">
                        Has the Company incurred any additional debt as a result of the COVID-19 emergency?
                    </div>

                    <div class="color-secondary-gray font-size-14 font-weight-normal mb-3">
                        Due to the unique effects of COVID-19, all valuations projecting into 2020 will have risk specific
                        COVID-19 risk questions.
                    </div>

                    <div class="row m-0">
                        <div class="col-md-12">
                            <radio-group-button [selectedOption]="currentReport.LATEST.COVID_ADD_DEBT" 
                            radioGroupButtonId="special-crp-covid-add-debt-type-radio-group"
                            [(ngModel)]="currentReport.LATEST.COVID_ADD_DEBT"
                                [btnList]="yesNo_Option" [isButton]="true" name="COVID_ADD_DEBT" #COVID_ADD_DEBT="ngModel" required id="COVID_ADD_DEBT"
                                (optionChange)="currentReport.LATEST.COVID_ADD_DEBT = $event; callUpdateAPI('COVID_ADD_DEBT')">
                            </radio-group-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>

<report-footer [nextBtnEnable]="currentReport && currentReport.LATEST && specialForm.valid" (buttonClicked)="footerButtonClick($event)">
</report-footer>